export enum SaleSaveToMailDocumentsMode {
	NONE = "none",
	IF_NO_PEPPOL = "if-no-peppol",
	ALL = "all",
}

export enum SaleSaveToPrintDocumentsMode {
	NONE = "none",
	IF_NO_MAIL = "if-no-mail",
	ALL = "all"
}

export class SaleSaveToData {
	public OriginalDocTypeID:number = 1;
	public FromDate:Date = new Date();
	public TillDate:Date = new Date();
	public ContactID:number = 0;

	public ToUseDocumentIDs:number[] = [];

	public TargetDocumentTypeID:number = 1;
	public TargetDocumentDate:Date = new Date();
	public TransferPaymentsToNewDocs:boolean = false;
	public SendViaPeppol:boolean = false;
	public MailDocumentsMode:SaleSaveToMailDocumentsMode = SaleSaveToMailDocumentsMode.NONE;
	public PrintDocumentsMode:SaleSaveToPrintDocumentsMode = SaleSaveToPrintDocumentsMode.NONE;
	public AddImportedFromSaleText:boolean = false;

	public constructor(){
		let savedSettings = JSON.parse(localStorage.getItem("sale-save-to-data-settings") || "{}");
		this.initSettingsFromSavedSettings("SendViaPeppol", savedSettings);
		this.initSettingsFromSavedSettings("MailDocumentsMode", savedSettings);
		this.initSettingsFromSavedSettings("PrintDocumentsMode", savedSettings);
		this.initSettingsFromSavedSettings("AddImportedFromSaleText", savedSettings);
	}

	private initSettingsFromSavedSettings(key:keyof SaleSaveToData, storedSettings:any){
		if (!storedSettings) return;
		if (!storedSettings[key]) return;
		(this[key] as any) = storedSettings[key];
	}

	public getJSON():any{
		return {
			OriginalDocTypeID: this.OriginalDocTypeID,
			FromDate: this.FromDate.toJSON(),
			TillDate: this.TillDate.toJSON(),
			ContactID: this.ContactID,

			ToUseDocumentIDs: [...this.ToUseDocumentIDs],

			TargetDocumentTypeID: this.TargetDocumentTypeID,
			TargetDocumentDate: this.TargetDocumentDate.toJSON(),
			SendViaPeppol: this.SendViaPeppol,
			TransferPaymentsToNewDocs: this.TransferPaymentsToNewDocs,
			MailDocumentsMode: this.MailDocumentsMode,
			PrintDocumentsMode: this.PrintDocumentsMode,
			AddImportedFromSaleText: this.AddImportedFromSaleText
		};
	}

	public saveDefaultSettings(){
		localStorage.setItem("sale-save-to-data-settings", JSON.stringify({
			SendViaPeppol: this.SendViaPeppol,
			MailDocumentsMode: this.MailDocumentsMode,
			PrintDocumentsMode: this.PrintDocumentsMode,
			AddImportedFromSaleText: this.AddImportedFromSaleText
		}));
	}
}